import { Pipe, PipeTransform } from '@angular/core';
import { LanguageFacade } from '@redux/facades/language.facade';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
declare var require: any;
@Pipe({ name: 'translatePipe', standalone: false })

export class TranslatePipe implements PipeTransform {
  private language = 'es';

  constructor(
    public languageFacade: LanguageFacade
  ) {
    const self = this;
    this.languageFacade.languageState$.pipe(take(1)).subscribe(
      ok => {
        self.language = ok.selected;
      }
    );
  }

  transform(value: any): string {
    if (value != null) {
      const find = value.split('.');
      const language = this.language;
      const data = require('../../../assets/lang/' + language + '.json');
      console.log(data);
      let count = 0;
      let dataTemp = data;
      for (const search of find) {
        count++;
        if (dataTemp.hasOwnProperty(search)) {
          if (count === find.length) {
            return dataTemp[search];
          } else {
            dataTemp = dataTemp[search];
          }
        } else {
          if (environment.show_lang_base) {
            return value;
          }
          else {
            return find[find.length - 1];
          }
        }
      }
    }
    return 'N/A';
  }
}
